import { atom } from 'jotai';

export interface DisableSliderState {
    disableSlider: boolean;
    showMobileSearchResultsAll: boolean;
}

/**
 * Atom to control whether images in tiles should be limited to a single image
 * True: Only shows first image
 * False: Shows image slider for multiple images
 */
export const disableSliderAtom = atom<DisableSliderState>({
    disableSlider: true,
    showMobileSearchResultsAll: false,
});
